import React from 'react'
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from 'react-share'

import { Facebook, LinkedIn, Twitter } from '../icons'
import { useCurrentUrl } from '../../hooks'

import styles from './share.module.scss'

interface Props {
  title?: string
  url?: string
}

export const Share: React.FunctionComponent<Props> = ({ title, url }) => {
  const currentUrl = useCurrentUrl()
  const shareUrl = url || currentUrl

  return (
    <>
      {title && <h5 className={`${styles.shareTitle} pink`}>{title}</h5>}
      <div className={styles.shareContainer}>
        <FacebookShareButton url={shareUrl} className={styles.shareButton}>
          <Facebook className={styles.shareIcon}/>
        </FacebookShareButton>
        <TwitterShareButton url={shareUrl} className={styles.shareButton}>
          <Twitter className={styles.shareIcon}/>
        </TwitterShareButton>
        <LinkedinShareButton
          url={shareUrl}
          className={`${styles.shareButton} ${styles.shareButtonLast}`}
        >
          <LinkedIn className={styles.shareIcon}/>
        </LinkedinShareButton>
      </div>
    </>
  )
}
